import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './Form';
import { formatDateString } from '@app/src/utils/helpers';
import { fetchProcessCip, setPaymentType } from '@app/src/views/CipGeneration/generateForm/state/processCip/actions';
import * as selectProcessCip from '@app/src/views/CipGeneration/generateForm/state/processCip/selectors';
import * as selectPaymentType from '@app/src/views/CipReport/filter/state/paymentType/selectors';
import { fetchPaymentType } from '@app/src/views/CipReport/filter/state/paymentType/actions';
import { SELECT_DOCUMENT, SELECT_CURRENCY, COUNTRY } from './constants';

const Container = reduxForm({
  form: 'generateForm',
  enableReinitialize : true,
  onSubmit(fields, dispatch, { url }) {
    dispatch(fetchProcessCip(fields, url));
  }
})(Form);

const validationMaxLengthPeru = (document: string): string => {
  switch (document) {
    case 'DNI':
      return '8';
    case 'RUC':
      return '11';
    case 'CE':
      return '12';
    case 'PAS':
      return '12';
    default:
      return '8';
  }
}

const validationMaxLengthEcuador = (document: string): string => {
  switch (document) {
    case 'CD':
      return '10';
    case 'CE':
      return '10';
    case 'RUC':
      return '13';
    case 'PAS':
      return '12';
    default:
      return '10';
  }
}

const validationMaxLength = (country: number, document: string) => {
  switch (country) {
    case COUNTRY.PERU:
      return validationMaxLengthPeru(document);
    case COUNTRY.ECUADOR:
      return validationMaxLengthEcuador(document);
  }
}

const getCurrentDate = () => {
  const today = new Date();
  const currentDay = today.getDate();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowDay = new Date(tomorrow).getDate();
  const tomorrowMonth = new Date(tomorrow).getMonth();
  const tomorrowYear = new Date(tomorrow).getFullYear();

  const isTomorrow = (): boolean => {
    const HOURS: number = new Date().getHours();
    const MINUTES: number = new Date().getMinutes();
    const MAX_HOURS: number = 23;
    const MAX_MINUTES: number = 30;
    return HOURS === MAX_HOURS && MINUTES >= MAX_MINUTES;
  };
  return isTomorrow() ? formatDateString(tomorrowDay, tomorrowMonth, tomorrowYear) : formatDateString(currentDay, currentMonth, currentYear);
}

const selector = formValueSelector('generateForm');

const mapStateToProps = state => ({
  initialValues: {
    userDocumentType: selectProcessCip.getUseridCountry(state) && SELECT_DOCUMENT[selectProcessCip.getUseridCountry(state)][0].value,
    currency: selectProcessCip.getUseridCountry(state) && SELECT_CURRENCY[selectProcessCip.getUseridCountry(state)][0].value,
    paymentType: selectProcessCip.getPaymentType(state)
  },
  isFetchingProcessCip: selectProcessCip.getIsFetching(state),
  errorMessageProcessCip: selectProcessCip.getErrorMessage(state),
  data: selectProcessCip.getData(state),
  isFetchingPaymentType: selectPaymentType.getIsFetching(state),
  errorMessagePaymentType: selectPaymentType.getErrorMessage(state),
  paymentTypes: selectPaymentType.getPaymentTypes(state),
  maxLength: validationMaxLength(Number(selectProcessCip.getUseridCountry(state)), selector(state, 'userDocumentType')),
  currency: selector(state, 'currency'),
  paymentType: selector(state, 'paymentType'),
  currentDate: getCurrentDate()
});

const mapDispatchToProps = dispatch => ({
  handleCleanDocument: () => dispatch(change('generateForm', 'userDocumentNumber', '')),
  handleCleanAmount: () => dispatch(change('generateForm', 'amount', '')),
  handleSetPaymentType: (value) => dispatch(setPaymentType(value)),
  handleSetFormDate: (value) => dispatch(change('generateForm', 'date', value)),
  handleGetPaymentTypes: (history) => dispatch(fetchPaymentType(process.env.API_PAYMENT_TYPE, history))
});

export const FormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
